var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { stringBuilder } from '../util';
const TuxToggleWrapper = forwardRef(function TuxToggle(props, ref) {
    const { className, disabled = false, id, label, leftLabel, onChange, rightLabel, value } = props, rest = __rest(props, ["className", "disabled", "id", "label", "leftLabel", "onChange", "rightLabel", "value"]);
    const classes = stringBuilder('toggle_container', className);
    return (_jsxs("div", Object.assign({ className: classes }, { children: [leftLabel && (_jsx("span", Object.assign({ "aria-hidden": "true", "data-testing": "left-label" }, { children: leftLabel }), void 0)), value, _jsx("input", Object.assign({}, rest, { checked: value, className: "toggle", disabled: disabled, id: id, onChange: (e) => props.onChange(e.target.checked), ref: ref, type: "checkbox" }), void 0), _jsx("label", Object.assign({ htmlFor: id }, { children: _jsx("span", Object.assign({ className: "sr-only" }, { children: label }), void 0) }), void 0), rightLabel && (_jsx("span", Object.assign({ "aria-hidden": "true", "data-testing": "right-label" }, { children: rightLabel }), void 0))] }), void 0));
});
export default TuxToggleWrapper;
